import React, { Fragment, useEffect, useRef } from 'react';
import { Alert } from 'react-bootstrap';

import IAlertMessage from '../../interfaces/IAlertMessage';
import HelperTime from '../../helpers/HelperTime';

import './styles.scss';

interface IAlertMessageProps {
    alert?: IAlertMessage;
    close?: () => void;
}

const AlertMessage = ({ alert, close }: IAlertMessageProps) => {
    const alertRef = useRef<HTMLDivElement>(null);

    useEffect(shoudScroll, [alert]);

    function shoudScroll() {
        if (alert?.goToMessage) {
            setTimeout(() => executeScroll(), HelperTime.secondsToMilliseconds(1));
        }
    }

    function executeScroll() {
        alertRef?.current?.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    if (!alert)
        return null;



    let variant = 'primary';
    let message = new Array<string>();

    if (alert.danger)
        variant = 'danger';
    else if (alert.warning)
        variant = 'warning';
    else if (alert.info)
        variant = 'info';
    else if (alert.success)
        variant = 'success';

    if (alert.error) {
        if (alert?.error?.response?.status === 403) {
            alert.heading = 'Atenção!'
            message = ['Você não tem permissão para acessar essa funcionalidade!'];
            variant = 'warning';
        } else if (alert.error?.response?.data?.data)
            message = [alert.error.response.data.data];
        else if (alert?.error?.response?.data?.errors && Array.isArray(alert?.error?.response?.data?.errors)) {

            message = alert?.error?.response?.data?.errors.map((e: any) => {
                if (typeof e === 'string')
                    return e;
                return null;
            });
        }
        else if (alert.error?.message)
            message = [alert.error.message];
        else
            message.push(alert.error);
    }

    return (
        <Alert
            variant={variant}
            ref={alertRef}
            dismissible={!!close}
            id="AlertComponent"
            onClose={close && (() => close())}>
            {alert?.heading && <Alert.Heading>{alert.heading}</Alert.Heading>}
            <p className="mb-0">
                {alert.message &&
                    <>
                        {alert.message}
                        <br />
                    </>
                }
                {message?.map((x, idx) => <Fragment key={idx}>{x}<br /></Fragment>)}
            </p>
            {
                alert?.footer &&
                <>
                    <hr />
                    <p className="mb-0 text-white">{alert.footer}</p>
                </>
            }
        </Alert>
    );
};

export default AlertMessage;